








import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component
export default class ViewLink extends Vue {
  @Prop({ default: 0 })
  public viewId!: number
  @Prop({ default: '' })
  public viewType!: string
  @Prop({ default: '' })

  @Prop({ default: '' })
  public title!: string
  public classType: string = 'primary'

  public get tooltip(): string {
    if (this.title) {
      return this.title
    }
    return '点击查看明细'
  }

  public openView() {
    let fn = 'view' + this.viewType
    window.eventBus.$emit(fn, this.viewId)
    return false
  }
}
